import { useEffect, useState } from 'react';

const SCRIPT_URL = 'https://pay.google.com/gp/p/js/pay.js';

let scriptPromise: Promise<void> | null = null;

function loadScript(): Promise<void> {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    if (window.google?.payments?.api?.PaymentsClient) {
      resolve();

      return;
    }

    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Pay script'));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

export default function useGooglePayScript(): { loaded: boolean } {
  const [loaded, setLoaded] = useState(() => !!window.google?.payments?.api?.PaymentsClient);

  useEffect(() => {
    if (loaded) return;

    loadScript().then(() => setLoaded(true));
  }, []);

  return { loaded };
}
